import { IBusinessDay, IBusinessDayState } from './types';
import { createSelector } from 'reselect';

export const selectLoadedState = (state: IBusinessDayState) => state.loaded;
export const selectBusinessDayList = (state: IBusinessDayState) => state.businessDayList;
export const selectBusinessDay = (state: IBusinessDayState) => state.businessDay;
export const selectSyncError = (state: IBusinessDayState) => state.error;
export const selectSyncState = (state: IBusinessDayState) => state.syncing;
export const selectBusinessDaySyncState = (state: IBusinessDayState) => state.businessDaySyncing;
export const selectBusinessDayLoadedState = (state: IBusinessDayState) => state.businessDayLoaded;
export const selectBusinessDaySavedState = (state: IBusinessDayState) => state.businessDaySaved;
export const selectBusinessDayDeletedState = (state: IBusinessDayState) => state.businessDayDeleted;

export const selectIndexedBusinessDayList = createSelector(
  selectBusinessDayList,
  (businessDayList) =>
    businessDayList.reduce((indexed: { [x: string]: any }, businessDay: IBusinessDay) => {
      if (businessDay.enterpriseUnitId) {
        indexed[businessDay.enterpriseUnitId] = businessDay;
      }
      return indexed;
    }, {})
);
